<mat-card-content>
  <div class="d-flex justify-content-between">
    <mat-card-title>{{data.lblTitle}}</mat-card-title>
    <span mat-dialog-close><mat-icon>close</mat-icon></span>
  </div>
  <mat-divider></mat-divider>
  <div class="row gy-3 text-results">
    <div class="col-12">
      <label for="reasonText">{{data.lblReason}}<span *ngIf="data.requiredReason" class="text-danger">*</span></label>
      <textarea matInput id="reasonText"
        [formControl]="reasonCtrl"
        placeholder="{{ data.phReason}}"
        [maxlength]="maxCharReason" 
        rows="4"></textarea>
      <mat-error *ngIf="reasonCtrl.invalid && reasonCtrl.touched && data.requiredReason">
              {{data.requiredHelper}}
            </mat-error>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div class="d-flex justify-content-end">
    <button mat-stroked-button (click)="close()" color="alternative" class="me-3">{{data.lblClose}}</button>
    <button mat-flat-button color="success" (click)="isOk()">
      <loading-button>
        <ng-template #icon>
          {{data.lblOk}}
        </ng-template>
      </loading-button>
    </button>
  </div>
</mat-card-content>